import { authService } from './auth.service';

const API_URL = import.meta.env.VITE_API_URL || 'http://localhost:8787';

export const documentAdminService = {
  async toggleRequiresSignature(
    documentId: string,
    requiresSignature: boolean
  ): Promise<void> {
    const result = await authService.fetchWithAuth(
      `${API_URL}/api/internal/documents/${documentId}/requires-signature`,
      {
        method: 'PATCH',
        body: JSON.stringify({ requiresSignature }),
      }
    );
    if (result && result.error) {
      throw new Error(result.error);
    }
  },

  async getSignatureInfo(documentId: string): Promise<any> {
    const result = await authService.fetchWithAuth(
      `${API_URL}/api/internal/documents/${documentId}/signature-info`
    );
    if (!result || result.error) {
      throw new Error(result?.error || 'Error al obtener firma');
    }
    return result.data;
  },
};